import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
const controller = rpcController("DescripcionPaquete");
const crud = rpcCrudService<models.DescripcionPaqueteDTO>(controller);

const otros = cacheResource({
    DescripcionesFiltradas: async (): Promise<models.DescripcionPaqueteDTO[]> => await controller("DescripcionesFiltradas")
},
    { DescripcionesFiltradas: true })
export const DescripcionPaquete = bindResource({ ...crud, ...otros });


// WEBPACK FOOTER //
// ./app/resources/items/descripcionespaquetes.tsx